<template>
    <Fragment>
        <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="green"></v-tabs-slider>
            <v-tab v-for="(item, idx) in tabs" :key="idx">
                {{ item.title }}
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item v-for="(item, idx) in tabs" :key="`tab-${idx}`">
                <component :is="item.component" v-model="guest"/>
            </v-tab-item>
        </v-tabs-items>
    </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';
import GuestHistory from './GuestHistory.vue';
import GuestInfo from './GuestInfo.vue';

import { mapActions, mapGetters } from 'vuex'

export default{
    data:()=>({
        tab: null,
        tabs: [{ title: 'Информация', component: 'GuestInfo' }, { title: 'История заказов', component: 'GuestHistory' }],
        guest: {}
    }),
    computed:{
        ...mapGetters(['guest_by_id']),
        guestId(){
            return this.$route.params.guestId
        },
    },
    methods:{
        ...mapActions(['getGuestById'])
    },
    async mounted() {
        if(!this.guest_by_id(this.guestId)) this.guest = await this.getGuestById(this.guestId) 
        else this.guest = {...this.guest_by_id(this.guestId)}
        
        await this.$store.dispatch('loadMenu')
    },
    components: {
        Fragment,
        GuestHistory,
        GuestInfo
    }
}
</script>